export default "__VITE_ASSET__BvkHpvjB__"